module.exports = __webpack_public_path__ + "static/img/200277.9bc0736b.png";